<script>
import { sync } from 'vuex-pathify'

import constants from '@/constants'
import firebase, { firebaseMessagingIsSupported } from '@/firebase'

import Update from '@/components/Update.vue'

export default {
  data () {
    return {
      isReloading: null
    }
  },
  computed: {
    token: sync('ServiceWorkerModule/token')
  },
  async created () {
    await this.serviceWorkerRegister()
  },
  methods: {
    async confirmUpdate (waitingWorker) {
      this.$buefy.modal.open({
        canCancel: [],
        component: Update,
        hasModalCard: true,
        parent: this,
        props: {
          impl: () => waitingWorker.postMessage({ action: 'skipWaiting' })
        }
      })
    },
    async initialiseFirebaseCloudMessaging (registration) {
      if (!firebaseMessagingIsSupported()) {
        return
      }
      const messaging = firebase.messaging()
      messaging.onMessage((message) => {
        this.$buefy.dialog.alert({
          message: message.notification.body,
          title: message.notification.title,
          type: 'is-primary'
        })
      })
      messaging.onTokenRefresh(() => {
        messaging.getToken().then(async (token) => {
          await this.setToken(token)
        })
      })
      messaging.usePublicVapidKey(constants.FIREBASEPUBLICVAPIDKEY)
      messaging.useServiceWorker(registration)
      Notification.requestPermission((permission) => {
        if (permission === 'granted') {
          messaging.getToken().then(async (token) => {
            await this.setToken(token)
          })
        }
      })
    },
    async serviceWorkerRegister () {
      if (navigator && navigator.serviceWorker) {
        navigator.serviceWorker.register('service-worker.js').then(async (registration) => {
          await this.initialiseFirebaseCloudMessaging(registration)
          registration.addEventListener('updatefound', () => {
            const installingWorker = registration.installing
            installingWorker.addEventListener('statechange', () => {
              if (installingWorker.state === 'installed') {
                this.confirmUpdate(registration.waiting)
              }
            })
          })
        })
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (!this.isReloading) {
            this.isReloading = true
            window.location.reload()
          }
        })
      }
    },
    async setToken (token) {
      this.token = token
    }
  }
}
</script>
